import { useEffect, useState } from 'react';
import FlightContiner from './FlightContiner';
import './AppAufaFliget.css';


export default function AppAufaFlight ({number, setNumber, dataFlightCar, setDataFlightCar, data, special, OnAlert}) {
    const [data2, setData2] = useState({});
    const [num, setNum] = useState(2);
    
    useEffect(() => {
        clickOnHead(2);
    }, [data])

    useEffect(() => {   
        clickOnHead(number);
    }, [number])

    function clickOnHead (num) {
        if (data) {
            if (num === 1) {
                setData2(data['S']);
            } else if (num === 2) {
                setData2(data['A']);
            } else if (num === 3) {
                setData2(data['R']);
            } else if (num === 4) {
                setData2(data['B']);
            }
        }
        setNumber(num);
        setNum(num)
    }

    return (
    <div>
        <div className="AufaMainSelect">
            <p className={number === 1 ? "AufaMainSelectSelected" : undefined} onClick={() => clickOnHead(1)} > מבצעים מיוחדים </p>
            <p className={number === 2 ? "AufaMainSelectSelected" : undefined} onClick={() => clickOnHead(2)} > טיסות הלוך </p>
            <p className={number === 3 ? "AufaMainSelectSelected" : undefined} onClick={() => clickOnHead(3)}> טיסות חזור </p>
            <p className={number === 4 ? "AufaMainSelectSelected" : undefined} onClick={() => clickOnHead(4)}> טיסות הלוך חזור </p>
        </div>

        <div className='aufa-flight-head-table'>
            { (data && data2 && Object.keys(data2).length > 0)  ? 
            <FlightContiner 
            data={data2} 
            dataFlightCar={dataFlightCar} 
            setDataFlightCar={setDataFlightCar} 
            type={num} 
            special={special}
            onAlert={OnAlert} 
            /> 
            : 
            <p className='no-flight-aufa'> אין טיסות  </p> 
            }
        </div>
    </div>
    )
}